import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Gursha" />
      <h1 className="headtext__cormorant">Describe Ethiopian Food?</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">The Ethiopian food is very distinct and rich.</p>
        </div>
        <p className="p__opensans"> It marries together earthy, spicy, tart, sour, and pungent flavors. A base seasoning, used in a wide variety of savory and spiced Ethiopian dishes, is a blend of spices known as Berbere. </p>
      </div>

      <div className="app__chef-sign">
        {/* <p>Kevin Luo</p>
        <p className="p__opensans">Chef & Founder</p>
        <img src={images.sign} alt="sign_image" /> */}
      </div>
    </div>
  </div>
);

export default Chef;
